import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get requests.
*/
export const getRequests = async (type: string, overview?: boolean, filter?: string): Promise<any> => {
    let overviewFilter = overview ? `&overview=true` : ``;
    let filterParam = filter ? `&filter=${filter}` : ``;

    let url = `${baseAxiosUrl}/api/metrics/requests?type=${type}${overviewFilter}${filterParam}`;
    return await axios.get(url);
}


/**
* Get usage.
*/
export const getUsage = async (realized?: boolean): Promise<any> => {
    let realizedFilter = realized ? `?realized=true` : ``;
    let url = `${baseAxiosUrl}/api/metrics/usage${realizedFilter}`;
    return await axios.get(url);
}

/**
* Get usage list.
*/
export const getUsageList = async (type: string, offset: number, limit: number, filters?: string): Promise<any> => {
    let ratingListRequest = {
        type: type,
        offset: offset,
        limit: limit,
        filters: filters ?? null,
    }

    let url = `${baseAxiosUrl}/api/metrics/usageList?data=${JSON.stringify(ratingListRequest)}`;
    return await axios.get(url);
}

/**
* Get realized usage list.
*/
export const getRealizedUsageList = async (type: string, offset: number, limit: number, filters?: string): Promise<any> => {
    let ratingListRequest = {
        type: type,
        offset: offset,
        limit: limit,
        filters: filters ?? null,
    }

    let url = `${baseAxiosUrl}/api/metrics/realizedUsageList?data=${JSON.stringify(ratingListRequest)}`;
    return await axios.get(url);
}

/**
* Get rating.
*/
export const getRating = async (type: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/metrics/rating?type=${type}`;
    return await axios.get(url);
}

/**
* Get rating list.
*/
export const getRatingList = async (type: string, offset: number, limit: number, filters?: string): Promise<any> => {
    let ratingListRequest = {
        type: type,
        offset: offset,
        limit: limit,
        filters: filters ?? null,
    }

    let url = `${baseAxiosUrl}/api/metrics/ratingList?data=${JSON.stringify(ratingListRequest)}`;
    return await axios.get(url);
}

/**
* Get meeting data list.
*/
export const getMeetingDataList = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/metrics/meetingDataList`;
    return await axios.get(url);
}